<div class="l-main" role="main">
    <div class="l-container">

        <div class="l-content">
            <!--<div class="panel-pane box--large">-->
           <div class="panel-pane box">
                <form action="#" class="search-directory" [formGroup]="reactiveForm">
                    <!-- <div>
                        <input type="text" name="search" class="search-popup__input" formControlName="searchValue"
                            [(ngModel)]="searchValue" placeholder="Search">
                        <input type="submit" value="People" class="search-directory__submit"
                            [disabled]="aFormGroup.invalid" [routerLink]="['/peoples-list', searchValue]"> <input
                            type="submit" value="Departments" class="search-directory__submit">
                    </div> -->
                    <div class="align-center">
                        <!-- <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (reset)="handleReset()"
                            (expire)="handleExpire()" (load)="handleLoad()" (success)="handleSuccess($event)"
                            [useGlobalDomain]="useGlobalDomain" [size]="size" [hl]="lang" [theme]="theme" [type]="type"
                            formControlName="recaptcha" [(ngModel)]="recaptcha">
                        </ngx-recaptcha2> -->

                        
                       <!--  <re-captcha formControlName="recaptchaReactive" (resolved)="addTokenLog('Normal mode resolved', $event)">
                        </re-captcha> -->
						<div class="col-12" class="directory-people-validation">
							<table style="margin-bottom: auto;margin: 10px;">
								<tr *ngIf="hasCaptchaExpired" style="border: none; padding: 0px;">
									<td colspan="2" style="border: none">
										<div class="directory-people-validation-error">Verification expired. Check the checkbox again.</div>
									</td>
								</tr>
								<tr style="border: none">
									<td style="border: none"><input type="checkbox" id="validationFormCheck1"
									class="form-check-input" formControlName="recaptchaReactive" [(ngModel)]="isCaptchaSuccess" (change)="addTokenLog('Normal mode resolved', $event)" required></td>
									<td style="border: none" class="directory-people-validation-label">I'm not a robot</td>
								</tr>
								
							</table>
						</div>

					</div>
                </form>
            </div>
            
            <div class="panel-pane bg-transparent align-center">

                <ul class="list--pipe">

                    <li><a href="">Visit the UC Davis directory</a></li>

                    <li><a href="https://org.ucdavis.edu/odr">Update my UC Davis directory listing</a></li>

                    <!--<li><a href="http://localhost/directory/">See All Departments</a></li>-->

                </ul>

            </div>
            
            <div class="panel-pane box" *ngIf="hasNoRecords">
                <!-- ********** Main content section ********** -->
                <div id="main_section" role="main">
                    <!-- Center column (primary content) -->
                    <div id="center_column">
                        <div id="center_column_inner_wrap">

                            <div class="repeating_content_block"></div>

                            <div id="directory_results_wrapper" >
                                No Search results
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="panel-pane box" *ngIf="peopleList?.length > 0">
                <!-- ********** Main content section ********** -->
                <div id="main_section" role="main">
                    <!-- Center column (primary content) -->
                    <div id="center_column">
                        <div id="center_column_inner_wrap">

                            <div class="repeating_content_block"></div>

                            <div id="directory_results_wrapper" >
                                <span *ngIf="peopleList?.length < 100">Search returned {{peopleList?.length}} results.</span><BR>
                                <span *ngIf="peopleList?.length == 100"><p class="alert"><em>Search results limited to 100. </em>
                                     Please <a routerLink="/home">refine your search</a> 
                                     if you would like more specific results.</p></span>
                                <table border="0" cellpadding="2" cellspacing="0" width="100%" >
                                    <thead><TR VALIGN="top">
                                        <th width="15%" bgcolor="#BCC5CF" align="left">Name</th>
                                        <th width="15%" bgcolor="#BCC5CF" align="left">Department</th>
                                        <th width="15%" bgcolor="#BCC5CF" align="left">E-mail</th>
                                        <th width="15%" bgcolor="#BCC5CF" align="left">Phone</th>
                                    </TR>
                                    </thead>
                                    <tbody *ngFor="let item of peopleList; let i = index">
                                    <TR VALIGN="top" 
                                        [ngClass]="{'oddRow': [i%2]==0 }" >
                                        <td align="left"><a routerLink="/people-details" [state]="{mothraId: item.userId}"
                                               >{{item.name}}</a>
                                        </td>
                                        <td align="left">{{item.department}}</td>
                                        <td align="left"><a href="{{item.mail}}">{{item.mail}}</a></td>
                                        <td align="left">{{item.telephoneNumber}}</td>
                                    </TR>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                    <!-- End center column -->

                    <!-- Optional right column -->

                    <!-- End optional right column -->
                </div>
                <!-- ********** End main content ********** -->
            </div>
        </div>
        <!--end .l-content-->

    </div>

</div>
<!--End role=main-->
<p class="privacy">
    <strong>Privacy Notice:</strong> This campus directory is the property
    of <a href="https://www.ucdavis.edu">
        <font size="3" color="navy">University
            of California, Davis.</font>
    </a> To protect the privacy of individuals listed
    herein, in accordance with the State of California Information
    Practices Act, this directory may not be used, rented, distributed, or
    sold for commercial purposes.
</p>